

const CONNECTION_STATE = {
  START: 0,
  CONNECTING: 1,
  CONNECTED: 2,
  NOT_CONNECTED: 3,
  UPDATE_AVAILABLE: 4,
  UPDATE_EXECUTING: 5,
  RECONNECTING: 6,
  UPDATE_DONE: 7,
  UPDATE_DONE_REFRESH: 8,
  UPDATE_HAS_CANCELED: 9,
  REDIRECT_TO_DASHBOARD: 10,
  UPDATE_IN_DASHBOARD: 11,
  ASKING_DOWNLOAD_ROOT_CERT: 12,
  UNABLE_UPDATE: 13,
  ROOT_CERT: 20
};

const PROD_UPDATE_SERVER_URL = 'https://testscannerupdate.rdmcorp.com/PROD-2025';

const EC9600_PARAMS = {
  MODEL: 'EC9600',
  VERSIONS: {
    _1_1_0_208: '1.1.0.208',
    _1_2_0_243: '1.2.0.243'
  }
}

export {CONNECTION_STATE, PROD_UPDATE_SERVER_URL, EC9600_PARAMS};
